var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
export function fetchWorkingDaysProgress() {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        const url = "/webapi/cross/working-days-progress";
        const response = yield HttpClient.get(url, Object.assign({}, params));
        return response;
    });
}
export function fetchLatestResultsUpdate() {
    return __awaiter(this, void 0, void 0, function* () {
        const url = "/webapi/cross/latest-results-update";
        const response = yield HttpClient.get(url);
        return response !== null && response !== void 0 ? response : { updated_at: null };
    });
}
